import { WarningIcon } from "@phosphor-icons/react";

interface InlineFormErrorProps {
    children: string;
    /** Larger text and icon for full-page forms (e.g. the classroom login). */
    isLarge?: boolean;
    "data-testid"?: string;
}

/** Red warning row announced to screen readers, shown under a form's inputs. */
const InlineFormError = (props: InlineFormErrorProps) => {
    return (
        <div
            role="alert"
            data-testid={props["data-testid"]}
            className="flex w-full items-start gap-xs"
        >
            <WarningIcon
                size={props.isLarge ? 30 : 24}
                className="text-p6-red shrink-0"
                aria-hidden="true"
            />
            <p className={`${props.isLarge ? "text-l" : "text-m"} text-p6-red`}>{props.children}</p>
        </div>
    );
};

export default InlineFormError;
